import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const api = axios.create();

// Base URL needs to be set a runtime to allow a single Docker image
// to run in different environments
function setBaseURL(request: AxiosRequestConfig): AxiosRequestConfig {
  request.baseURL = window.env.MYCOREMS_ACCOUNTS.API_URL;
  return request;
}

// Setting this option when creating the axios (although it's meant to)
// instance does not work so an interceptor must be used.
function sendCookies(request: AxiosRequestConfig): AxiosRequestConfig {
  request.withCredentials = true;
  return request;
}

function fetchCreatedResource(response: AxiosResponse) {
  if (response.status !== 201 || Object.keys(response.data).length > 0) {
    return response;
  }
  return api.get(response.headers.location);
}

function createQueryResult(response: AxiosResponse): AxiosResponse {
  if (response.status !== 200 || !('x-total-items' in response.headers)) {
    return response;
  }
  return Object.assign(response, {
    data: {
      total: parseInt(response.headers['x-total-items'], 10),
      items: response.data,
    },
  });
}

api.interceptors.request.use(setBaseURL);
api.interceptors.request.use(sendCookies);
api.interceptors.response.use(fetchCreatedResource);
api.interceptors.response.use(createQueryResult);

export default api;
